import { FC } from 'react';
import { Divider, DividerProps } from 'antd';
import classnames from 'classnames';

export const ILSDivider: FC<DividerProps> = (props) => {
  return <Divider className={classnames({ 'divider-vertical-full': props.type === 'vertical' })} {...props} />;
};
